import store from "store"
import { call, put } from "redux-saga/effects"
import { DckActionTypes } from "dck-redux"
import { fetchFormData, fetchJson, INVALID_TOKEN, parseFetchError } from "../../lib/utils"

function delay(ms) {
  return new Promise(resolve => setTimeout(() => resolve(true), ms))
}

/**
 * Manage and execute saga queries
 *
 * @param {*} url 
 * @param {*} method 
 * @param {*} body 
 * @param {*} processType 
 * @param {*} isJSONData 
 * @param {*} resultAction 
 * @returns 
 */
const makeSagaQuery = function*(url, method, body, processType, isJSONData, resultAction) {

  try {

    yield put({
      type: DckActionTypes.ASYNC_PROCESS_START,
      processCode: processType,
    })

    const state = store.get("sessionData"),
    response = yield call(isJSONData ? fetchJson : fetchFormData, method, url, state.access_token, body)

    yield put({
      type: DckActionTypes.ASYNC_PROCESS_STOP,
      processCode: processType,
      result: { success: true },
    })

    if (resultAction) {

      const result = resultAction(response)
      if(result) {
        yield put(result)
      }
    }

    return response
  }
  catch(error) {

    console.error(error)
    const content = parseFetchError(error)

    if (content.text === INVALID_TOKEN) {
      yield put({
        type: DckActionTypes.SIGN_OUT
      })
    }

    yield put({
      type: DckActionTypes.ASYNC_PROCESS_STOP,
      processCode: processType,
      result: {
        success: false,
        status: content.status,
        text: content.text,
      },
    })

    return false
  }
}

export { makeSagaQuery, delay }



// WEBPACK FOOTER //
// ./src/redux/sagas/utils.js